import React, { useEffect } from 'react';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import Card from './Card';
import './main.css'; 
import Contact from '../Contact/Contact';
import Approach from './Approach';
import Common from './Common';
import Header from '../Navbar/Header';




const Main = () => {
  useEffect(() => {
    const faders = document.querySelectorAll('.fade-in');
  
    const appearOptions = {
      threshold: 0.2, // kicsit előbb figyel
      rootMargin: "0px 0px -200px 0px" // előbb elkezdi tölteni
    };
  
    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      });
    }, appearOptions);
  
    faders.forEach((fader, index) => {
      const el = fader as HTMLElement;
      el.style.transitionDelay = `${index * 0.03}s`; // kicsit lassabb chain effekt
      appearOnScroll.observe(el);
    });
  }, []);
  return (
    <>
    <Navbar/>
    {/* <Header /> */}
   {/* <Card /> */}
   
    <section className="aboutMe-section ">
    <div className="aboutMe-container fade-in">
        {/* Bal oldali kép */}
        <div className="aboutMe-image-wrapper" style={{backgroundImage: 'url(main2.png)'}}>
          <h1 className="aboutMe-title fade-in">
            Approaching risk and safety in the complex modern landscape
        </h1>
        <p className='aboutMe-text-p fade-in' >
            Approaching the understanding and management of human risk and safety in the complex modern landscape.
            As economic and geopolitical uncertainty has increased together with rapid technological advancement,
            the risk and threat associated with human behaviour has also increased significantly.
        </p>
        </div>

        {/* Jobb oldali szöveg */}
        <div className="aboutMe-text">
      
        </div>
    </div>
    </section>
    <Card />
    <Approach />    
    <Common />
    <Contact />
    <Footer />
    </>
  );
};

export default Main;
